import * as React from 'react';

import IconCollectionsStar from './IconCollectionsStar';

export const collectionsStar = () => <IconCollectionsStar />;

export default {
    title: 'Icons/Collections/Star',
    component: IconCollectionsStar,
    parameters: {
        notes: "`import IconCollectionsStar from 'box-ui-elements/es/icons/collection/IconCollectionsStar';`",
    },
};
